/**
 * Nut cuon len dau trang.
 *
 * Dung IntersectionObserver tren mot moc cao 1px thay vi nghe su kien scroll:
 * nghe scroll la chay ham hang tram lan moi giay va lam khung hinh giat tren
 * dien thoai yeu.
 *
 * MOC PHAI CAO 1px, KHONG DUOC 0: IntersectionObserver khong bao cho phan tu
 * co dien tich bang 0. Da tra gia dung loi nay o 17fishing ngay 01/10/2026 —
 * cuon het mot trang 1914px ma khong moc nao ban, va hong lang le: van co so
 * lieu, chi la moi khoi deu bao "khong ai doc".
 */
const nut = document.querySelector('.x-top');

if (nut) {
  const moc = document.createElement('span');
  moc.style.cssText = 'position:absolute;top:100vh;height:1px;width:1px;';
  moc.setAttribute('aria-hidden', 'true');
  document.body.prepend(moc);

  new IntersectionObserver(
    ([e]) => {
      nut.hidden = e.isIntersecting;
    },
    { threshold: 0 }
  ).observe(moc);

  nut.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
